(function () {
  function readVariants() {
    try { const el = document.querySelector('[data-variant-json]');
      return el ? JSON.parse(el.textContent.trim()) : [];
    } catch { return []; }
  }
  const variants = readVariants();
  const $ = (s, r=document) => r.querySelector(s);

  function findVariantById(id){ return variants.find(v => String(v.id) === String(id)); }
  function variantText(v){ return (!v || v.title === 'Default Title') ? '' : [v.option1,v.option2,v.option3].filter(Boolean).join(' · '); }

  // —— current hero (variant image → visible gallery → og:image) ——
  function currentHeroURL(v){
    let u = (v && v.featured_image && v.featured_image.src) ? v.featured_image.src : null;
    if (!u){
      const img = $('.product__main-photos .slick-current img, .product__media .is-selected img, .product__slideshow .slick-current img, .product-gallery .is-selected img');
      if (img) u = img.currentSrc || img.src || (img.getAttribute('srcset')||'').split(' ')[0];
    }
    if (!u){ const og = $('meta[property="og:image"]'); if (og) u = og.content; }
    if (u && u.startsWith('//')) u = 'https:' + u;
    return u;
  }

  // —— ensure meta exists then set it ——
  function ensureMeta(selector, attrs){
    let el = $(selector);
    if (!el){
      el = document.createElement('meta');
      if (selector.includes('property=')) el.setAttribute('property', selector.match(/property="([^"]+)"/)[1]);
      if (selector.includes('name='))     el.setAttribute('name',     selector.match(/name="([^"]+)"/)[1]);
      document.head.appendChild(el);
    }
    Object.entries(attrs).forEach(([k,v]) => el.setAttribute(k,v));
    return el;
  }

  // —— JSON-LD Product: put active image first ——
  function updateJSONLDImage(primaryUrl){
    const script = Array.from(document.querySelectorAll('script[type="application/ld+json"]'))
      .find(s => s.textContent.includes('"@type":"Product"'));
    if (!script) return;
    try {
      const data = JSON.parse(script.textContent);
      const imgs = Array.isArray(data.image) ? data.image.map(String).filter(Boolean) : [];
      const rest = imgs.filter(x => x !== primaryUrl);
      data.image = [primaryUrl, ...rest].slice(0, 20);
      script.textContent = JSON.stringify(data);
    } catch {}
  }

  // —— NEW: hidden, first-in-DOM image for Babylist —— 
  function ensureHiddenLeadImage(url){
    let img = $('#bl-primary-image');
    if (!img){
      img = document.createElement('img');
      img.id = 'bl-primary-image';
      img.alt = 'Product image';
      // Make it the very first node in <body>, before the header/logo
      document.body.insertBefore(img, document.body.firstChild);
      // Truly invisible
      img.width = 1; img.height = 1;
      img.style.cssText = 'position:absolute;left:-99999px;top:-99999px;width:1px;height:1px;opacity:0;pointer-events:none;';
    }
    img.src = url;
  }

  function baseProductTitle(){
    const h1 = $('h1.product-single__title, .product-single__title');
    return h1 && h1.textContent.trim() ? h1.textContent.trim()
      : document.title.replace(/\s+-\s+The Crown Prints.*$/, '').trim();
  }
  function shopSuffix(){ const parts = document.title.split(' - '); return parts.length>1 ? parts.pop() : document.title; }

  function applyForVariant(v){
    const url = new URL(location.href);
    const vt  = variantText(v);
    const t   = vt ? `${baseProductTitle()} - ${vt}` : baseProductTitle();

    // canonical & og:url
    document.querySelectorAll('link[rel="canonical"]').forEach(l => l.href = url.href);
    ensureMeta('meta[property="og:url"]',   { content: url.href });

    // titles
    ensureMeta('meta[property="og:title"]', { content: t });
    ensureMeta('meta[name="twitter:title"]',{ content: t });
    document.title = `${t} - ${shopSuffix()}`;

    // images (all the hints)
    const hero = currentHeroURL(v);
    if (hero){
      ensureMeta('meta[property="og:image"]',  { content: hero });
      ensureMeta('meta[name="twitter:image"]', { content: hero });
      let link = document.querySelector('link[rel="image_src"]');
      if (!link){ link = document.createElement('link'); link.rel = 'image_src'; document.head.appendChild(link); }
      link.href = hero;
      updateJSONLDImage(hero);
      ensureHiddenLeadImage(hero);        // ← this is what Babylist will grab
    }
    ensureMeta('meta[property="og:image:alt"]', { content: t });
  }

  function setup(){
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    const idInput = form.querySelector('[name="id"]');
    if (!idInput) return;

    function onChange(){
      const vid = idInput.value;
      const v   = findVariantById(vid);
      const u   = new URL(location.href);
      u.searchParams.set('variant', vid);
      history.replaceState(null, '', u);
      applyForVariant(v);
    }

    onChange();
    document.addEventListener('variant:change', onChange);
    document.addEventListener('product:variant-change', onChange);
    form.addEventListener('change', onChange);
    new MutationObserver(onChange).observe(idInput, { attributes:true, attributeFilter:['value'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();